/**
 * The five account types that can sign in to the web platform. Each one gets
 * its own accent colour, used for the card border, header fill and submit
 * button, so a signed-in role is recognisable from the first screen onwards.
 *
 * `accent` is a CSS custom property rather than a literal so the palette stays
 * defined in one place (index.css) for the rest of the app to reuse.
 */
export type RoleKey =
  | "collector"
  | "estate"
  | "agent"
  | "gallery"
  | "verifier";

export type Role = {
  key: RoleKey;
  label: string;
  accent: string;
};

export const ROLES: readonly Role[] = [
  { key: "collector", label: "Collector sign-in", accent: "var(--role-collector)" },
  { key: "estate", label: "Artist / Estate sign-in", accent: "var(--role-estate)" },
  { key: "agent", label: "Agent sign-in", accent: "var(--role-agent)" },
  { key: "gallery", label: "Gallery sign-in", accent: "var(--role-gallery)" },
  { key: "verifier", label: "Verification sign-in", accent: "var(--role-verifier)" },
];
